// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_wrapper__P33LP","loader":"loading_loader__0UgYT","spin":"loading_spin__mlFY3"};